import React, { useState } from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, Modal, Divider, Chip } from '@mui/material';
import QuizModal from '../components/QuizModal';
import questions from '../data/questions.json';

interface Question {
  idQuestion: string;
  type: string;
  question: string;
  A: string;
  B: string;
  C: string;
  D: string;
  E?: string;
  correct: string;
}

const disciplinasMap: { [key: string]: string[] } = {
  'Regulamentos de Tráfego Aéreo VFR': ['PPA', 'PCH'],
  'Meteorologia': ['PPA', 'PCH', 'PCA/IFR', 'CMS'],
  'Navegação VFR': ['PPA', 'PCH'],
  'Teoria de Voo': ['PPA', 'PCH', 'PCA/IFR'],
  'Conhecimentos Técnicos': ['PPA', 'PCH', 'PCA/IFR'],
  'Regulamentos de Tráfego Aéreo IFR': ['PCA/IFR'],
  'Navegação IFR': ['PCA/IFR', 'CMS'],
  'Conhecimentos técnicos gerais': ['CMA'],
  'Performance, Peso e Balanceamento': ['CMA'],
  'Emergência, segurança e sobrevivência': ['CMS'],
  'Regulamentação da aviação civil e da profissão do aeronauta': ['CMS'],
  'Medicina aeroespacial e primeiros socorros': ['CMS'],
  'Conhecimentos gerais de aeronaves': ['CMS']
};

const Simulados: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState('');
  const [filteredQuestions, setFilteredQuestions] = useState<Question[]>([]);

  const handleOpen = (disciplina: string) => {
    setCategory(disciplina);
    const typeMap: { [key: string]: string } = {
      'Regulamentos de Tráfego Aéreo VFR': 'REG',
      'Meteorologia': 'MET',
      'Navegação VFR': 'NAV',
      'Teoria de Voo': 'TV',
      'Conhecimentos Técnicos': 'CT',
      'Regulamentos de Tráfego Aéreo IFR': 'REGIFR',
      'Navegação IFR': 'NAVIFR',
      'Conhecimentos técnicos gerais': 'CTG',
      'Performance, Peso e Balanceamento': 'PPB',
      'Emergência, segurança e sobrevivência': 'ESS',
      'Regulamentação da aviação civil e da profissão do aeronauta': 'RPA',
      'Medicina aeroespacial e primeiros socorros': 'PSS',
      'Conhecimentos gerais de aeronaves': 'CGA'
    };
    const questionType = typeMap[disciplina];
    if (questionType) {
      setFilteredQuestions(questions.filter(q => q.type === questionType));
      setOpen(true);
    }
  };

  const handleClose = () => {
    if (window.confirm('Deseja abandonar a prova?')) {
      setOpen(false);
    }
  };

  return (
    <>
      
      <div className="Simulados">
        <Container className="centered-card">
          <Typography variant="h5" gutterBottom>
            Escolha uma disciplina - FVR Simulados ANAC
          </Typography>
          <p>Seja muito bem-vindo à nossa Ferramenta de Valor Recorrente (FVR),</p>
          <p>Este é o sistema de simulados ANAC baseado em marketing de ferramenta educacional. Estamos em constante desenvolvimento, 
          aprimorando nossa FVR para oferecer a melhor experiência de preparação.</p>
          <p>O objetivo desta ferramenta é oferecer um ambiente de simulado recorrente para que você possa testar seus conhecimentos 
          quantas vezes precisar. Nossa FVR está em expansão, aumentando constantemente a base de questões e categorias disponíveis.</p>
          <Divider />
          <List>
            {Object.keys(disciplinasMap).map((disciplina) => (
              <ListItem button key={disciplina} onClick={() => handleOpen(disciplina)}>
                <ListItemText 
                  primary={disciplina} 
                  secondary="Clique para acessar os simulados desta disciplina"
                />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {disciplinasMap[disciplina].map((categoria) => (
                    <Chip key={categoria} label={categoria} size="small" color="primary" variant="outlined" />
                  ))}
                </Box>
              </ListItem>
            ))}
          </List>
          <Divider />
          <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic' }}>
            💡 Esta é uma FVR (Ferramenta de Valor Recorrente) - retorne sempre que precisar praticar!
          </Typography>
        </Container>
        <Modal open={open} onClose={handleClose}>
          <Box className="quiz-modal">
            <QuizModal category={category} numQuestions={20} questions={filteredQuestions} setOpen={setOpen} />
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default Simulados;
